import React from 'react';
import { PillComponent, PillContent, Text, Amount } from './Pill.styles.js';

var Pill = function Pill(_a) {
  var _b = _a.active,
      active = _b === void 0 ? false : _b,
      amount = _a.amount,
      onClick = _a.onClick,
      text = _a.text;
  return React.createElement(PillComponent, {
    active: active,
    onClick: onClick,
    onKeyDown: function onKeyDown(e) {
      if (e.key === 'Enter') onClick();
    },
    tabIndex: 0
  }, React.createElement(PillContent, null, React.createElement(Text, null, text), amount !== undefined && React.createElement(Amount, null, "(", amount, ")")));
};

export { Pill };